import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "native-base";
import { forHumans } from "@madmedical/medical";
import { useLocation } from "@madmedical/routing";
import { useTranslation } from "@madmedical/i18n";
import ConsultationButton from "../molecules/ConsultationButton";
import RoutableTabs from "../molecules/RoutableTabs";
import useResponsive from "../util/useResponsive";
import Button from "../atoms/Button";
const MeasurementsTabs = ({ metricType, isPatient, downloadPressed, insulinUser = false, }) => {
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const location = useLocation();
    const isAdministration = location.pathname.includes("/insulin/administrations");
    const addDiabetMenu = () => {
        if (insulinUser) {
            return [
                {
                    title: t("insulin"),
                    route: "insulin",
                    params: {},
                },
                {
                    title: t("measures:insertions"),
                    route: "insulin_administrations",
                    params: {},
                },
            ];
        }
        return [];
    };
    return (_jsx(Box, Object.assign({ testID: "tabs", px: {
            base: 2,
            md: 4,
        }, backgroundColor: "white", borderColor: "gray.100", borderBottomWidth: 1 }, { children: _jsxs(Stack, Object.assign({ direction: "row", space: 2, width: "full", alignItems: "center" }, { children: [_jsx(RoutableTabs, { tabs: [
                        {
                            title: t(`measures:${forHumans(metricType)}`),
                            route: "measurements",
                            params: { metricType },
                        },
                        {
                            title: t("measures:title"),
                            route: "measurements_list",
                            params: { metricType },
                        },
                        ...addDiabetMenu(),
                    ], _tab: { px: 2, py: 4 } }), !isSmallScreen && isPatient && !isAdministration && (_jsx(Box, Object.assign({ ml: "auto" }, { children: _jsx(ConsultationButton, {}) }))), !isSmallScreen && isAdministration && downloadPressed && (_jsx(Box, Object.assign({ ml: "auto" }, { children: _jsx(Button, Object.assign({ variant: "outlined", leftIconName: "documentDownload", onPress: downloadPressed }, { children: t("downloadData") })) })))] })) })));
};
export default MeasurementsTabs;
